import api from "./api";
import { API_APPOINTMENTS_HOOKS } from "../constants/urls";


export const hook = {
    getAll: async () => (await api.get(API_APPOINTMENTS_HOOKS)).data,
    getById: async (id) => (await api.get(`${API_APPOINTMENTS_HOOKS}/${id}`)).data,
    create: async (hook) => (await api.post(API_APPOINTMENTS_HOOKS, hook)).data,
    delete: async (id) => (await api.delete(`${API_APPOINTMENTS_HOOKS}/${id}`)).data,
};